import { QRFC } from "./QRFC";

export class QOneUse extends QRFC {
  constructor() {
    super();
    this.fOrg = null;
    this.fUser = null;
    this.fDir = null;
    this.fFileName = null;
    this.fcrc = null;
    this.fPubDownload = false;
  }

  InitOneUse(callbackObj, pubDownload) {
    this.fPubDownload = pubDownload;
    this.InitRemoteCall(callbackObj, "POST", true, false);
  }

  SetParams(curOrg, user, curDir, filename) {
    this.fOrg = curOrg;
    this.fUser = user;
    this.fDir = curDir;
    this.fFileName = filename;

    this.AddParameter("dir", curDir);
    this.AddParameter("fileName", filename);
    this.AddParameter("org", curOrg);
    this.AddParameter("user", user);
  }

  GetCallName() {
    return "qoneuse";
  }

  DoTransactionComplete(response, callBackObj) {
    var result = null;
    try {
      result = JSON.parse(response);
    } catch (err) {
      console.error("qoneuse returned an unparseable response", err);
      return;
    }

    if (result == null || result.result !== "Success") return;

    var theUrl = "/ServerSide/";
    theUrl += this.fPubDownload ? "qdownloadpublish" : "qdownloadfile";
    callBackObj.DoDownloadResult(
      theUrl,
      this.fOrg,
      this.fUser,
      this.fDir,
      this.fFileName,
      this.fcrc,
      this.fPubDownload,
      result.pdt ?? null
    );
  }
}
